<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>Filter
        <CButton style="float:right;margin-left:10px;" size="sm" color="info" @click="addNoteModal()">Add New Note</CButton>
        <CButton style="float:right;" size="sm" color="success" @click="addModal()">Add New Subtract Entry</CButton>
      </CCardHeader>
      <CCardBody>
        <div class="col-sm-12 text-center">
          <label style="width:100%;float:left;text-align:center;">Date</label>
          <input type="date" class="form-control ml-auto mr-auto" @change="getData()" style="width:250px;" v-model="date" />
        </div>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardHeader>Entries</CCardHeader>
      <CCardBody>
        <table v-if="data" class="table">
          <thead>
            <tr>
              <th>Division</th>
              <th>Sold To</th>
              <th>Amount</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="data.length">
            <tr v-for="val in data">
              <td>{{val.area}}</td>
              <td>{{val.sold_to_name}}</td>
              <td>{{val.amount}}</td>
              <td>{{val.date}}</td>
              <td>
                <CButton size="sm" color="danger" @click="remove(val)">Remove</CButton>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" style="text-align:center;">No Entries</td>
            </tr>
          </tbody>
        </table>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>Notes</CCardHeader>
      <CCardBody>
        <table v-if="notes" class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Text</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="notes.length">
            <tr v-for="val in notes">
              <td>{{val.date}}</td>
              <td>{{val.text}}</td>
              <td>
                <CButton size="sm" color="danger" @click="removeNote(val)">Remove</CButton>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" style="text-align:center;">No Entries</td>
            </tr>
          </tbody>
        </table>
      </CCardBody>
    </CCard>

    <CModal
      title="Add New Entry"
      :show.sync="modal"
      color="success"
    >
      <div style="width:100%;float:left;">
        <div class="col-12 text-center mt-2">
          Select Date <input type="date" class="form-control ml-auto mr-auto" @change="getSoldTo()" v-model="entryDate" />
        </div>
        <div class="col-12 text-center mt-2">
          Division
          <select v-model="area" v-if="divisions" @change="getSoldTo()" class="form-control">
            <option value="">Select Division</option>
            <option v-for="val in divisions" :value="val">{{val}}</option>
          </select>
        </div>
        <div class="col-12 text-center mt-2">
          Sold To
          <v-select v-if="soldToOptions" label="sold_to_name" v-model="sold_to" :options="soldToOptions"></v-select>
        </div>
        <div class="col-12 text-center mt-2">
          Type
          <select v-model="type" class="form-control">
            <option value="">Select Type</option>
            <option v-for="val in types" :value="val">{{val}}</option>
          </select>
        </div>
        <div class="col-12 text-center mt-2">
          Amount 
          <input type="text" v-model="amount" class="form-control" />
        </div>
      </div>
      <template #footer>
        <CButton @click="modal = false, submitData()" color="success">Submit</CButton>
        <CButton @click="modal = false" color="danger">Cancel</CButton>
      </template>
    </CModal>

    <CModal
      title="Add Note Entry"
      :show.sync="noteModal"
      color="infoe"
    >
      <div style="width:100%;float:left;">
        <div class="col-12 text-center mt-2">
          Select Date <input type="date" class="form-control ml-auto mr-auto" v-model="note.date" />
        </div>
        <div class="col-12 text-center mt-2">
          Note 
          <textarea type="text" v-model="note.text" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <template #footer>
        <CButton @click="noteModal = false, submitNote()" color="success">Submit</CButton>
        <CButton @click="noteModal = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getData = function () {
  const postData = {
    date: this.date
  }
  axios.post(this.$apiAdress + '/api/getSubtractData?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data.subtract
    this.notes = response.data.notes
  })
}

methods.getSoldTo = function () {
  if (this.entryDate && this.area) {
    const postData = {
      area: this.area,
      date: this.entryDate
    }
    axios.post(this.$apiAdress + '/api/getSoldToByDivisions?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      // this.data = response.data
      this.soldToOptions = response.data
    })
  }
}

methods.addModal = function () {
  this.modal = true
}

methods.submitData = function () {
  const postData = {
    area: this.area,
    amount: this.amount,
    date: this.entryDate,
    sold_to: this.sold_to,
    type: this.type
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/submitSubtractData?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.date = this.entryDate
    this.getData()
    this.area = ''
    this.amount = ''
    this.entryDate = ''
    this.soldToOptions = null
    this.sold_to = ''
    this.type = ''
  })
}

methods.submitNote = function () {
  const postData = {
    note: this.note
  }
  axios.post(this.$apiAdress + '/api/submitNote?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
  })
}

methods.remove = function (val) {
  const postData = {
    val: val
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/removeSubtractData?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.getData()
  })
}

methods.removeNote = function (val) {
  const postData = {
    val: val
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/removeNote?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.getData()
  })
}

methods.addNoteModal = function () {
  this.noteModal = true
}

export default {
    // ===Component name
    name: "SubtractAmount",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          date: '',
          data: null,
          modal: false,
          noteModal: false,
          notes: null,
          note: {
            date: '',
            text: ''
          },
          divisions: ['ASI', 'Global Brand Solutions', 'Imperial', 'Outdoor', 'CORPORATE', 'GOLF', 'DTC', 'NIKE HEADWEAR', 'NIKE LICENSE', 'OUTDOOR', 'PETER MILLAR', 'SUPPLY CHAIN'],
          types: ['daily_booked', 'daily_shipped', 'booked_units'],
          area: '',
          amount: '',
          entryDate: '',
          soldToOptions: null,
          sold_to: ''
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.date = moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
